import { render, staticRenderFns } from "./Consulta.vue?vue&type=template&id=2abd3785&scoped=true&"
import script from "./Consulta.vue?vue&type=script&lang=js&"
export * from "./Consulta.vue?vue&type=script&lang=js&"
import style0 from "./Consulta.vue?vue&type=style&index=0&id=2abd3785&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd3785",
  null
  
)

export default component.exports